/*
 * TwoFive — Ajustes del carrito (lateral y /cart). Va con assets/twofive-cart-ui.css.
 *
 *   1. Línea del guante de regalo de Black November:
 *      · muestra el modelo real («Atlanta Basic Blackout») en vez de «Regalo Black November · Basic»;
 *      · una sola línea de datos: «Talla 3 · 24,99 € GRATIS» (sin repetir propiedades ni opciones);
 *      · sin selector de cantidad ni papelera (el regalo es siempre 1); en su lugar «Cambiar modelo o talla»,
 *        que quita el regalo para volver a elegirlo en el bloque de Black November (assets/bn-gift.js);
 *      · etiqueta naranja «REGALO» sobre la foto.
 *   2. Línea «Ahorras» encima del subtotal (solo tienda B2C): suma de (precio de comparación o precio) × unidades
 *      menos lo que se paga. Los precios de comparación salen de /products/<handle>.js.
 *
 *   3. Cabecera «Tu carrito · N productos» y tarjeta de envío gratis («Envío gratis · faltan X €» + barra),
 *      calculada con el umbral que ya trae la barra del tema (data-shipping-threshold).
 *
 * No modifica archivos del tema: actúa sobre el HTML del carrito y se reaplica cada vez que el tema lo repinta.
 */
(function () {
  'use strict';
  if (window.__tfCartUi) return;
  window.__tfCartUi = true;

  var CONF = window.TF_CART_UI || {};
  var GIFT_PROP = 'Regalo', GIFT_VALUE = 'Black November';
  var LOG = '[tf-cart-ui]';

  var fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  var money = function (cents) { return fmt.format(cents / 100); };
  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  };
  var baseFetch = window.fetch.bind(window);

  var cart = null;
  function getCart() {
    return baseFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { cart = c; return c; });
  }

  // Precios de comparación por variante (caché por producto).
  var compareCache = {};
  function compareFor(item) {
    var h = item.handle;
    if (!h) return Promise.resolve(null);
    if (!compareCache[h]) {
      compareCache[h] = baseFetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var map = {};
          ((p && p.variants) || []).forEach(function (v) { map[v.id] = v.compare_at_price || 0; });
          return map;
        }).catch(function () { return {}; });
    }
    return compareCache[h].then(function (map) { return map ? (map[item.variant_id] || 0) : 0; });
  }

  function isGift(item) { return !!(item.properties && item.properties[GIFT_PROP] === GIFT_VALUE); }
  function opt(item, names) {
    var o = (item.options_with_values || []).filter(function (x) { return names.indexOf(String(x.name).toLowerCase()) !== -1; })[0];
    return o ? o.value : '';
  }

  // ─── 1. Línea del regalo ────────────────────────────────────────────
  function decorateGiftLines() {
    if (!cart) return;
    (cart.items || []).forEach(function (item) {
      if (!isGift(item)) return;
      document.querySelectorAll('.cart-item[data-line-key="' + CSS.escape(item.key) + '"]').forEach(function (row) {
        var model = opt(item, ['modelo', 'model']) || item.product_title;
        var size = opt(item, ['talla', 'size']);
        var compare = item.original_price; // precio «antes» que enseña el tema para el regalo
        var sig = item.key + '|' + model + '|' + size;
        if (row.__tfGift === sig && row.querySelector('.tf-gift-meta')) return;
        row.__tfGift = sig;
        row.classList.add('tf-gift-line');

        var media = row.querySelector('.cart-item__media');
        if (media && !media.querySelector('.tf-gift-badge')) {
          var b = document.createElement('span'); b.className = 'tf-gift-badge'; b.textContent = 'REGALO';
          media.appendChild(b);
        }
        var title = row.querySelector('.cart-item__title a, .cart-item__title');
        if (title) title.textContent = model;

        var content = row.querySelector('.cart-item__content') || row;
        var meta = content.querySelector('.tf-gift-meta');
        if (!meta) { meta = document.createElement('div'); meta.className = 'tf-gift-meta'; }
        var eyebrow = '<p class="tf-gift-eyebrow">Tu guante de regalo</p>';
        meta.innerHTML =
          '<p class="tf-gift-line__info">' + (size ? 'Talla ' + esc(size) + ' · ' : '') +
          (compare > 0 ? '<s>' + money(compare) + '</s> ' : '') + '<strong>GRATIS</strong></p>' +
          '<button type="button" class="tf-gift-change" data-bn-gift-remove data-key="' + esc(item.key) + '">Cambiar modelo o talla</button>';
        var h = content.querySelector('.cart-item__title');
        if (h) {
          if (!content.querySelector('.tf-gift-eyebrow')) h.insertAdjacentHTML('beforebegin', eyebrow);
          h.insertAdjacentElement('afterend', meta);
        } else content.appendChild(meta);
      });
    });
  }

  // «6» → «Talla 6» en los productos normales del carrito lateral.
  function labelSizes() {
    if (!cart) return;
    (cart.items || []).forEach(function (item) {
      if (isGift(item)) return;
      var opts = item.options_with_values || [];
      if (!opts.length) return;
      document.querySelectorAll('.cart-item[data-line-key="' + CSS.escape(item.key) + '"] dl:not(.cart-item__properties):not(.cart-item__bundle-options) dd').forEach(function (dd, i) {
        var o = opts[i]; if (!o) return;
        var n = String(o.name).toLowerCase();
        if ((n === 'talla' || n === 'size') && dd.textContent.trim() === String(o.value)) dd.textContent = 'Talla ' + o.value;
      });
    });
  }

  // ─── 3. Cabecera y envío gratis ─────────────────────────────────────
  function renderHeader() {
    if (!cart) return;
    var n = cart.item_count || 0;
    var txt = '· ' + n + (n === 1 ? ' producto' : ' productos');
    document.querySelectorAll('cart-drawer .cart-drawer__title, #main-cart-items .cart__title').forEach(function (t) {
      var span = t.querySelector('.tf-count');
      if (!span) { span = document.createElement('span'); span.className = 'tf-count'; t.appendChild(span); }
      if (span.textContent !== txt) span.textContent = txt;
    });
  }
  function renderShipping() {
    document.querySelectorAll('shipping-bar').forEach(function (bar) {
      var top = bar.parentNode;
      if (!top) return;
      var threshold = Number(bar.getAttribute('data-shipping-threshold')) || 0;
      if (!threshold) return;
      var total = cart ? cart.total_price : Number(bar.getAttribute('data-cart-total')) || 0;
      var left = Math.max(0, threshold - total);
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      var html = '<span class="tf-ship__icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6.5h10.5v9H3z"/><path d="M13.5 9.5h4l3 3.2v2.8h-7"/><circle cx="7" cy="17.2" r="1.8"/><circle cx="17" cy="17.2" r="1.8"/></svg></span><div class="tf-ship__body"><div class="tf-ship__row"><strong>Envío gratis</strong><span>' +
        (left > 0 ? 'faltan ' + money(left) : '✓ conseguido') + '</span></div><div class="tf-ship__bar"><i style="width:' + pct + '%"></i></div></div>';
      var box = bar.nextElementSibling && bar.nextElementSibling.classList.contains('tf-ship') ? bar.nextElementSibling : null;
      if (!box) {
        box = document.createElement('div'); box.className = 'tf-ship';
        // en /cart la barra del tema existe en dos sitios (móvil y escritorio): heredamos su visibilidad
        if (!bar.closest('cart-drawer')) box.className += ' ' + Array.prototype.filter.call(bar.classList, function (c) { return /hide|show/.test(c); }).join(' ');
        bar.insertAdjacentElement('afterend', box);
      }
      bar.classList.add('tf-ship-hidden');
      box.classList.toggle('is-done', left <= 0);
      box.hidden = !!(cart && !cart.item_count);
      if (box.__h !== html) { box.innerHTML = html; box.__h = html; }
      top.classList.add('tf-ship-ready');
    });
  }

  // ─── 2. «Ahorras» ───────────────────────────────────────────────────
  var savingsSeq = 0;
  function updateSavings() {
    if (!cart || CONF.b2b) return;
    var seq = ++savingsSeq;
    Promise.all((cart.items || []).map(function (it) {
      return compareFor(it).then(function (cmp) {
        var unit = Math.max(cmp || 0, it.original_price || 0);
        return Math.max(0, unit * it.quantity - it.final_line_price);
      });
    })).then(function (vals) {
      if (seq !== savingsSeq) return;
      var total = vals.reduce(function (a, b) { return a + b; }, 0);
      placeSavings(total);
    }).catch(function (e) { console.warn(LOG, 'savings', e); });
  }
  var lastSavings = 0;
  function placeSavings(total) {
    lastSavings = total;
    var spots = [];
    var d = document.querySelector('#CartDrawer-FormSummary .cart-drawer__summary-total');
    if (d) spots.push(d);
    var p = document.querySelector('.cart__summary#cart-summary .cart__summary-total');
    if (p && !p.closest('cart-drawer')) spots.push(p);
    spots.forEach(function (spot) {
      var row = spot.parentNode.querySelector(':scope > .tf-savings');
      if (total <= 0) { if (row) row.remove(); return; }
      if (!row) {
        row = document.createElement('div'); row.className = 'tf-savings';
        spot.parentNode.insertBefore(row, spot);
      }
      var html = '<span>Ahorras</span><span class="tf-savings__amount">−' + money(total) + '</span>';
      if (row.innerHTML !== html) row.innerHTML = html;
    });
  }

  // ─── Repintado ──────────────────────────────────────────────────────
  var busy = false;
  function apply() {
    decorateGiftLines();
    labelSizes();
    renderHeader();
    renderShipping();
    placeSavings(lastSavings);
  }
  function refresh() {
    if (busy) return;
    busy = true;
    getCart().then(function () { apply(); updateSavings(); })
      .catch(function (e) { console.warn(LOG, e); })
      .then(function () { busy = false; });
  }

  // El tema reemplaza el HTML del carrito → volver a aplicar (sin pedir el carrito si no ha cambiado).
  var moTimer = null;
  new MutationObserver(function () {
    if (moTimer) return;
    moTimer = setTimeout(function () {
      moTimer = null;
      var needs = document.querySelector('.cart-item:not(.tf-seen)');
      document.querySelectorAll('.cart-item:not(.tf-seen)').forEach(function (r) { r.classList.add('tf-seen'); });
      if (needs) refresh(); else apply();
    }, 60);
  }).observe(document.body, { childList: true, subtree: true });

  // Cambios del carrito (tema, regalo, códigos) → recalcular.
  var prevFetch = window.fetch;
  var fTimer = null;
  window.fetch = function (input) {
    var p = prevFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          clearTimeout(fTimer); fTimer = setTimeout(refresh, 700);
        }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();